<template>
  <component
    :is="tag"
    :class="$style.card"
    :style="{
      'background-image': `url('${imageSource}')`
    }"
  >
    <div
      :class="$style.cardContent"
    >
      <lv-heading
        level="3"
        tag="h3"
        version2
        :class="$style.cardContentHeading"
      >
        {{ contentData.title }}
      </lv-heading>
      <p
        :class="$style.cardContentText"
        v-html="contentData.lead"
      />
      <lv-button
        :to="contentData.url"
        styling="small-secondary-light"
        shrink
        :class="$style.cardContentButton"
      >
        {{ $awt('aw.pages.prize_draw.button_text') }}
      </lv-button>
    </div>
  </component>
</template>

<script>

  import { LvHeading, LvButton } from '~~/common/components/loginet-vue-shop/index';

  import { mapState } from 'pinia';
  import { useUserInterfaceStore } from '~~/common/stores/userInterface';
  import { webpFallback } from '~~/common/utils';
  import { getBackgroundImages } from '~~/common/utils/imageHelper.js';

  export default {
    name: 'AwPrizeGameCard',
    components: {
      LvHeading,
      LvButton,
    },
    props: {
      contentData: {
        type: Object,
        required: true,
      },
      tag: {
        type: String,
        default: 'div',
      },
    },
    computed: {
      ...mapState(useUserInterfaceStore, {
        screenRange: state => state.mediaQueries,
      }),
      imageSource () {
        const images = [
          {
            ...this.contentData.media?.desktopCardImage,
            media: this.contentData.media?.desktopCardImage && this.contentData.media?.mobileCardImage ? `(min-width: ${this.$styleVariables.breakpointTablet})` : undefined,
          },
          this.contentData.media?.mobileCardImage,
        ];

        const sources = webpFallback(getBackgroundImages(this.screenRange['tablet-min'] ? images : images.reverse()));
        return sources?.[0]?.url;
      },
    },
  };
</script>

<style module lang="scss" rel="stylesheet/scss">
.card {
  position: relative;
  overflow: hidden;
  min-height: 293px;
  border-radius: 24px;
  background-position: center;
  background-size: cover;
  box-shadow: 0 0 32px 0 rgba($color-olive-750, 0.4);

  &::after {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    content: "";
    background: linear-gradient(to bottom, rgba($color-black, 0) 0%, rgba($color-black, 0.32) 100%);

  }

  &Content {
    position: relative;
    z-index: 2;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    height: 100%;
    padding: 20px;
    color: $color-white;
    @include tablet (min) {
      padding: 20px 16px;
    }

    &Heading {
      margin-bottom: 8px !important;
    }

    &Text {
      font-size: 12px;
      line-height: 16px;
      margin-bottom: 20px !important;
      @include tablet (min) {
        font-size: 14px;
        line-height: 20px;
      }
    }

    &Button {
      width: min-content;
    }
  }
}
</style>
